import { START_LOADER, STOP_LOADER } from "./types";
import leaveMessageService from "../services/leaveMessage.service";
export const leaveMessageAction = (payload) => (dispatch) => {
  dispatch({ type: START_LOADER });
  return leaveMessageService.leaveMessage(payload).then((resp) => {
    dispatch({ type: STOP_LOADER });
    return resp.data;
  });
};
